import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ConnectedGuide } from '../../compounds/category-guide-card';
import { useMeta, useEntity } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var ConnectedGuideCard = function ConnectedGuideCard(props) {
  var _useMeta = useMeta(['guideCard'], {}),
      showDescription = _useMeta.showDescription,
      showDate = _useMeta.showDate,
      dateFormat = _useMeta.dateFormat,
      showLink = _useMeta.showLink,
      linkText = _useMeta.linkText,
      _useMeta$variant = _useMeta.variant,
      metaVariant = _useMeta$variant === void 0 ? props.variant : _useMeta$variant;

  var _useEntity = useEntity(props.entity),
      link = _useEntity.link,
      url = _useEntity.url,
      _useEntity$variants = _useEntity.variants,
      variants = _useEntity$variants === void 0 ? [] : _useEntity$variants,
      variant = _useEntity.variant;

  return _jsx(ConnectedGuide, _objectSpread(_objectSpread({}, props), {}, {
    showDescription: props.showDescription !== undefined && props.showDescription && showDescription,
    showDate: showDate,
    showLink: showLink,
    dateFormat: dateFormat,
    linkText: linkText,
    variant: variant || metaVariant || 'readMoreCard',
    entity: link || variants[0],
    url: url
  }));
};

export default ConnectedGuideCard;
//# sourceMappingURL=connected-guide-card.js.map